/**
 * @file index.tsx
 *
 * @fileoverview Renders featured blog teasers.
 */
import { FormattedMessage } from 'react-intl';
import BlogSearchBlogTeaserCell from '~/jobiqo/components/BlogSearch/components/BlogTeaserCell';
import { BlogPost } from '~/jobiqo/models/blog';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Text } from '~/vcl/atoms/13-text/03-text';
import styles from './featuredBlogs.module.scss';

interface BlogSearchFeaturedBlogsProps {
  /**
   * The featured blogs.
   */
  blogs: BlogPost[];
}

export default function BlogSearchFeaturedBlogs({
  blogs,
}: BlogSearchFeaturedBlogsProps) {
  if (blogs.length === 0) {
    return null;
  }

  return (
    <Spacing marginBottom={[10, 11]} marginTop={[4, 6]}>
      <Text className={styles.featuredBlogsTitle}>
        <FormattedMessage
          id="featured_blog_articles_title"
          defaultMessage="Featured articles"
        />
      </Text>
      <Grid columns={[1, 2, 3]}>
        {blogs.map((blogPost: BlogPost) => (
          <BlogSearchBlogTeaserCell blogPost={blogPost} key={blogPost.id} />
        ))}
      </Grid>
    </Spacing>
  );
}
export { BlogSearchFeaturedBlogs };
